import { App, Button, Card, Col, Input, message, Modal, Pagination, Row, Space, Spin, Table } from 'antd'
import React, { useCallback, useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import debounce from 'lodash.debounce';
import { EyeFilled, LoadingOutlined, DeleteOutlined, EditOutlined, PlusOutlined, BarChartOutlined, TeamOutlined } from "@ant-design/icons";
import { CREATE_GROUP, DELETE_USER_GROUP, LIST_GROUP } from '../../apis/apis';
import CulsightPageLoader from '../../../Admin-panel/components/CulsightPageLoader';
import UserGroupCard from './UserGroupCard';

function UserGroup() {

  // const NAME_REGEX = /^[A-Za-z\s]+$/;

  const navigate = useNavigate();
  const { notification, modal } = App.useApp();
  const debounceRef = useRef(null);

  const [loading, setloading] = useState(true);
  const [pagination_loading, set_pagination_loading] = useState(false);
  const [table_data, set_table_data] = useState([]);
  const [current_page, set_current_page] = useState(
    Number(localStorage.getItem("user_group_page")) || 1
  );
  const [pageSize, setPageSize] = useState(
  Number(localStorage.getItem("user_group_page_size")) || 9
);
  const [total_pages, set_total_pages] = useState("");
  const [total_groups, set_total_groups] = useState("");
  const [search_query_name, set_search_query_name] = useState(
    localStorage.getItem("user_group_search") || ""
  );
  const [name, set_name] = useState("");
  const [errors, set_errors] = useState("");
  const [nameerrors, set_nameerrors] = useState({});

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    set_name("");
    set_errors("");
    set_nameerrors({});
    setIsModalOpen(true);
  };

  // ✅ Frontend validation handler
  const handleNameChange = (e) => {
    const value = e.target.value;
    set_name(value);

    let errorObj = {};

    if (!value.trim()) {
      errorObj.name = "Group name is required.";
    }
    // else if (!NAME_REGEX.test(value)) {
    //   errorObj.name = "Only alphabets and spaces are allowed.";
    // }

    set_nameerrors(errorObj);
  };

  const handleOk = async () => {

    // ✅ Frontend Validation Check
    if (Object.keys(nameerrors).length > 0) {
      notification.error({
        message: "Validation Error",
        description: nameerrors.name,
      });
      return;
    }

    if (!name.trim()) {
      notification.error({
        message: "Validation Error",
        description: "Group name is required.",
      });
      return;
    }

    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("name", name);

      const response = await CREATE_GROUP(FORM_DATA);

      if (response?.data?.status) {
        notification.success({
          message: "Successful",
          description: response?.data?.message,
        });
        localStorage.setItem("user_group_page", current_page);
        localStorage.setItem(
          "user_group_search",
          search_query_name
        );
        navigate("/assign-user/" + btoa(response?.data?.data?.id));
      } else {
        set_errors(response?.data?.errors);
        notification.error({
          message: "Failed",
          description: response?.data?.errors?.name || "Something went wrong",
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      notification.error({
        message: "Error",
        description: "Server error. Please try again later.",
      });
    }
  };

  const handleCancel = () => setIsModalOpen(false);



  const handleInput = (e) => {
    const value = e.target.value;

    if (value && !search_query_name) {
      localStorage.setItem(
        "user_group_last_search_page",
        current_page
      );
    }

    set_search_query_name(value);

    localStorage.setItem(
      "user_group_search",
      value
    );

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {

      const pageToLoad = value
        ? 1
        : Number(
          localStorage.getItem(
            "user_group_last_search_page"
          )
        ) || 1;

      set_current_page(pageToLoad);

      LIST_API(
        pageToLoad,
        value
      );

    }, 500);
  };

  const LIST_API = async (
    page = current_page,
    search = search_query_name
  ) => {
    const FORM_DATA = new FormData();

    FORM_DATA.append("page", page);
     FORM_DATA.append("per_page", pageSize);

    if (search) {
      FORM_DATA.append("name", search);
    }

    const API_CALL = await LIST_GROUP(FORM_DATA);

    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data || []);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
      set_total_groups(API_CALL?.data?.total_groups);
    }

    setloading(false);
    set_pagination_loading(false);
  };

  useEffect(() => {
    LIST_API(
      Number(localStorage.getItem("user_group_page")) || 1,
      localStorage.getItem("user_group_search") || ""
    );
  }, []);
  const columns = [
    {
      title: "Group Name",
      render: (_, record) => <span>{record.name}</span>,
    },
    {
      title: "User Count",
      render: (_, record) => <span>{record.user_count}</span>,
    },
    {
      title: "Action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            size="small"
            onClick={() => navigate("/assign-user/" + btoa(record.id))}
          >
            <EditOutlined />
          </Button>
          <Button
            size="small"
            type="primary"
            onClick={() =>
              navigate("/view-group/" + btoa(record.id), {
                state: {
                  groupName: record.name,
                },
              })
            }
          >
            <EyeFilled />
          </Button>

          <Button
            danger
            type="primary"
            size="small"
            onClick={() => handleDelete(record.id)}
          >
            <DeleteOutlined />
          </Button>
        </Space>
      ),
    },
  ];

 const pagination_on_change = async (page, size) => {
  localStorage.setItem("user_group_page", page);
  localStorage.setItem("user_group_page_size", size);

  setPageSize(size);
  set_pagination_loading(true);

  const FORM_DATA = new FormData();
  FORM_DATA.append("page", page);
  FORM_DATA.append("per_page", size);

  if (search_query_name) {
    FORM_DATA.append("name", search_query_name);
  }

  const API_CALL = await LIST_GROUP(FORM_DATA);

  if (API_CALL?.data?.status) {
    set_table_data(API_CALL?.data?.data || []);
    set_current_page(API_CALL?.data?.current_page);
    set_total_pages(API_CALL?.data?.total_pages);
    set_total_groups(API_CALL?.data?.total_groups);
  }

  set_pagination_loading(false);
};

  const handleDelete = (id) => {
    modal.confirm({
      title: "Are you sure you want to delete this User Group ?",
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        setloading(true)
        const FORM_DATA = new FormData();
        FORM_DATA.append("id", id);
        try {
          const response = await DELETE_USER_GROUP(FORM_DATA);
          if (response?.data?.status) {
            message.success("User Group deleted successfully");
            LIST_API();
          } else {
            message.error("Failed to delete User Group");
          }
        } catch (err) {
          message.error("Something went wrong");
        } finally {
          setloading(false);
        }
      }
    });
  };

  return (
    <div className='lms-body'>
      <Row>
        <Col span={12}>
          <h1 style={{ margin: "0px", padding: "0px" }}>User Group</h1>
          <span style={{ color: "gray", fontWeight: "600", fontSize: "15px" }}>Organize users into groups for targeted campaigns</span>
        </Col>
        <Col span={12}>

          <Button
            type="primary"
            size='large'
            style={{ marginLeft: "10px", float: "right" }}
            onClick={showModal}
          >
            <PlusOutlined />
            Add Group
          </Button>
        </Col>
      </Row>

      <Row style={{ marginTop: "10px" }}>
        <Col span={24}>
          <Card style={{ height: "90px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "-15px" }}>
              <div
                style={{
                  background: "#ede9fe",
                  padding: "10px",
                  borderRadius: "12px",
                }}
              >
                <TeamOutlined style={{ color: "#8c3add", fontSize: 24 }} />
              </div>

              <div>
                <h1 style={{ margin: 0 }}>{total_groups}</h1>
                <span style={{ color: "gray", fontSize: "15px" }}>
                  Total Groups
                </span>
              </div>
            </div>
          </Card>
        </Col>
      </Row>


      <Card style={{ marginTop: "10px" }}>
        <Row>
          <Col span={20}>
            <Input
              addonBefore={<span>Name</span>}
              placeholder="Search by name"
              value={search_query_name}
              onChange={handleInput}
              size="large"
            />
          </Col>
        </Row>
{loading || pagination_loading ? (
  <CulsightPageLoader />
) : (
  <>
    <Row gutter={[16, 16]} style={{ marginTop: "15px" }}>
      {Array.isArray(table_data) &&
        table_data.map((item) => (
          <Col xs={24} sm={12} md={8} lg={8} key={item.id}>
            <UserGroupCard
              data={item}
              current_page={current_page}
              onDelete={handleDelete}
              search_query_name={search_query_name}
            />
          </Col>
        ))}
    </Row>

    {total_pages > 0 && (
      <div style={{ float: "right", marginTop: "20px" }}>
        <Pagination
          current={current_page}
          total={total_groups}
          pageSize={pageSize}
          onChange={pagination_on_change}
          showSizeChanger
          pageSizeOptions={["9", "18", "27", "36"]}
        />
      </div>
    )}
  </>
)}

        {/* ✅ Modal */}
        <Modal
          title="Add New Group"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          okText="Save"
          okButtonProps={{ disabled: !!nameerrors?.name }}
        >
          <Input
            placeholder="Enter your group Name"
            value={name}
            showCount
            onChange={handleNameChange}
          />

          {/* Frontend Error */}
          {nameerrors?.name && (
            <div style={{ color: "red", marginTop: "6px", fontSize: "13px" }}>
              {nameerrors.name}
            </div>
          )}

          {/*  API Error */}
          {errors?.name && (
            <div style={{ color: "red", marginTop: "6px", fontSize: "13px" }}>
              {errors.name}
            </div>
          )}

        </Modal>
      </Card >
    </div >
  )
}

export default UserGroup;
